import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import { DivisionId, SenderId, ClientId, PrevilageId } from "../../helper/HelperAuth";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsCreate } from '../../store/constants'
import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'
import ActionGetQualityRating from '../../store/action/QualityRating/Fetch'
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'

class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Quality Rating",
            isadmin:false,
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            actionId: this.handleActionId(),
            searchForm: fromJS({
                "client-id": '',
                "sender-id": '',
            }),
            columns: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                { className: "col-sm-1", field: "sender-id", caption: "Phone Number", allowSearch: true },
                { className: "col-sm-1", cfield: "icon", field: "quality-rating", caption: "Quality Rating", allowSearch: true  },
                { className: "col-sm-1", field: "sender", caption: "Sender", allowSearch: true },
            ],
            errors: fromJS({}),
            disrest: true,
        };

        this.showContent = this.showContent.bind(this);
        this.handleFindSearch = this.handleFindSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCustomIcon = this.handleCustomIcon.bind(this);
    }

    async componentDidMount() {
        let formVal = this.state.searchForm
        await this.props.actionGetAccessModule(PrevilageId);
        let restrict = this.handleActionId()
        this.props.actionGetAllClient()
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        if (restrict == 5 || isAdmin == false) {
            this.props.actionGetAllSender(ClientId)
            formVal = formVal.set("client-id", ClientId)
            formVal = formVal.set("sender-id", SenderId)
            this.setState({
                searchForm: formVal,
                disrest: true
            })
        } else {
            this.setState({
                disrest: false
            })
        }
    }

    handleCustomIcon(row){
        switch(row.get("quality-rating")){
            case "HIGH":
                return <span><i className="material-icons text-success" style={{fontSize:"7pt"}} >brightness_1</i> High</span>
            case "LOW":
                return <span><i className="material-icons text-danger" style={{fontSize:"7pt"}} >brightness_1</i> Low</span>
            case "MEDIUM":
                return <span><i className="material-icons text-warning" style={{fontSize:"7pt"}} >brightness_1</i> Medium</span>
            default:
                return <span><i className="material-icons text-secondary" style={{fontSize:"7pt"}} >brightness_1</i> {row.get('quality-rating')}</span>
        }
    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'Quality Rating') {
                action = array[i]['action-id'];
                this.state.actionId = array[i]['action-id'];
            }
        }
        return action;
    }


    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field, value);
        if (field === 'client-id') {
            formVal = formVal.set('sender-id', '')
             this.setState({ client_id: value })
            this.props.actionGetAllSender(value);
        }
        this.setState({ searchForm: formVal })

    }

    handleCancelForm(refresh) {
        if (refresh) {
            this.handleFindSearch(1);
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let sender_id = searchForm.get('sender-id');
        let client_id = searchForm.get('client-id');
        let division_id = DivisionId;
        let sender = [];
        var bodyFInd = {};
        let res = null;
        var isAdmin = this.state.isadmin;

        if(!client_id) {
            toast.error("Client Cannot be Empty!", toast.POSITION.TOP_RIGHT);
            return false;
        }

        if(!sender_id && client_id != 0) {
            if (PrevilageId != 1 && isAdmin == false) {
                client_id = ClientId;
            }
            this.props.actionGetAllSender(client_id, null)

            setTimeout(() => {
                res = this.props.senderall;
                if (res.size > 0) {
                    sender = [];
                }

                {
                    res.map((data, i) =>
                        sender.push(data.get('sender-id'))
                    )
                }
                if(sender[0] == '') sender = []
                bodyFInd = {
                    "client-id": client_id,
                    "sender-id": sender
                }
                this.props.actionGet(page, bodyFInd);

            }, 3000);

        } else {
            if (PrevilageId != 1 && isAdmin == false) {
                client_id = ClientId;
                if (this.state.actionId == 5) {

                    this.props.actionGetAllSender(client_id, division_id)
                } setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) {
                        sender = [];
                    }
                    {
                        res.map((data, i) =>
                            sender.push(data.get('sender-id'))
                        )
                    }

                    if (sender_id != "") sender = [sender_id]
                    if (sender[0] == '') sender = []
                    bodyFInd = {
                        "client-id": client_id,
                        "sender-id": sender
                    }
                    this.props.actionGet(page, bodyFInd);
                }, 3000);
            } else {
                sender = [];
                sender.push(sender_id)
                if (sender[0] == '') sender = []
                bodyFInd = {
                    "client-id": client_id,
                    "sender-id": sender
                }
                this.props.actionGet(page, bodyFInd);
            }
        }
    }

    refreshGrid(page, search) {
        this.handleFindSearch(page)
    }

    handleFind() {
        this.handleFindSearch(1)
    }

    showContent() {
        var form = this.state.form;

            const items = this.props.qualityrating ? fromJS(this.props.qualityrating) : fromJS({});
            return (
                <CustomGrid
                    title="Upload File"
                    columns={this.state.columns}
                    items={items}
                    handlePageChanged={this.handlePageChanged}
                    handleCustomIcon={ this.handleCustomIcon }
                >
                </CustomGrid>
            )
    }

    render() {
        const { searchForm, form } = this.state;
        const title = form.get('show') ?  "Upload File" : "Quality Rating";
        const classHide = title == 'Quality Rating' ? 'card' : 'card hidden'
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className={classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                    disabled={this.state.disrest}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            accessmodules: state.user.accessmodules,
            clientall: state.user.clientall,
            senderall: state.user.senders,
            qualityrating: state.user.qualityrating
        }
    },
    dispatch => bindActionCreators({
        actionGetAllClient: ActionGetAllClient,
        actionGetAllSender: ActionGetAllSender,
        actionGet: ActionGetQualityRating,
        actionGetAccessModule: ActionGetAccessModule,
        actionFindByGroupId:ActionFindByGroupId
    }, dispatch),
)(Page);